import HttpRequest from "@/api/axios";

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default {
    submintJobOrder(data) {
        return axios.request({
            url: "jobs/create-resume",
            method: "post",
            data
        })
    },
    submintOrder(data) {
        return axios.request({
            url: "user/create-order",
            method: "post",
            data
        })
    },
    regCheck(data)
    {
        return axios.request({
            url: "user/reg-check",
            method: "post",
            data
        })
    },
    applyPay(data)
    {
        return axios.request({
            url: "pay/apply-pay",
            method: "post",
            data
        })
    },
    orderlist(data)
    {
        return axios.request({
            url: "user/order-list",
            method: "post",
            data
        })
    },
    refundOrder(data)
    {
        return axios.request({
            url: "order-refund/apply",
            method: "post",
            data
        })
    },
    refundDetail(data)
    {
        return axios.request({
            url: "order-refund/detail",
            method: "post",
            data
        })
    },
    refundOrderCheck(data)
    {
        return axios.request({
            url: "order-refund/check",
            method: "post",
            data
        })
    }
}
